import axios from "../utils/axios";
import Swal from 'sweetalert2';
import { throttle } from 'lodash';

export const storeModelPaper = async (formData) => {
  try {

    const swalLoading = Swal.fire({
      title: 'Uploading...',
      text: 'Please wait while we upload your model paper.',
      icon: 'info',
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const response = await axios.post(`/modelpapers`, formData);

    swalLoading.close();

    if (!response) {
      Swal.fire({
        title: 'Processing...',
        text: 'Your Model Paper is being processed. Please wait.',
        icon: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    } else {
      Swal.fire({
        title: 'Model Paper uploaded successfully!',
        icon: 'success'
      });
      return response.data;
    }
  } catch (error) {
    Swal.close();
    Swal.fire({
      title: 'Error',
      text: error.response?.data?.message || 'Failed to upload Model Paper. Please try again.',
      icon: 'error'
    });
  }
};


export const getModelPapers = throttle(async (page) => {
  try {
    const { data } = await axios.get(`/modelpapers?page=${page}`);
    const { modelPapers } = data;
    return modelPapers;

  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.response?.data?.message || 'Failed to fetch model papers',
      icon: 'error',
    });
  }
}, 3000, {
  leading: true,
  trailing: false
});

export const deleteModelPaper = async (id) => {
  try {
    const swalLoading = Swal.fire({
      title: 'Deleting...',
      text: 'Please wait while we delete your model paper.',
      icon: 'info',
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const { data } = await axios.delete(`/modelpapers/${id}`);

    swalLoading.close();

    if (!data) {
      Swal.fire({
        title: 'Processing...',
        text: 'Your model paper is being deleted. Please wait.',
        icon: 'info',
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    } else {
      Swal.fire({ title: `Model Paper deleted successfully`, icon: "success" });
    }
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.response?.data?.message || 'Failed to delete model paper',
      icon: 'error',
    });

  }
}

export const updateModelPaper = async (id, formData) => {
  try {
    const swalLoading = Swal.fire({
      title: 'Updating...',
      text: 'Please wait while we update your model paper.',
      icon: 'info',
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    let { data } = await axios.post(`/modelpapers/${id}`, formData);

    swalLoading.close();

    if (data) {
      Swal.fire({
        title: 'Success',
        text: 'Model paper updated successfully',
        icon: 'success',
      });
    }
  }
  catch (error) {
    console.error('Error on updating model paper:', error);
    Swal.fire({
      title: 'Error',
      text: error.response?.data?.message || 'Failed to update model paper ',
      icon: 'error',
    });

    return [];
  }
}

export const fetchClassModelPapers = (async (grade, cb) => {
  try {
    const { data } = await axios.get(`/modelpapers/class/${grade}`);
    let { classModelPapers } = data;
    if (!Array.isArray(classModelPapers)) {
      classModelPapers = []
    }
    cb(classModelPapers);

  } catch (error) {
    console.error(`Error fetching model papers for class ${grade}:`, error);
    Swal.fire({
      title: 'Error',
      text: error.response?.data?.message || `Error fetching Model Papers for class ${grade}`,
      icon: 'error',
    });
    return [];
  }
});

export const getModelPaperById = throttle(async (id) => {
  try {
    let { data } = await axios.get(`/modelpapers/${id}`);
    return data;
  }
  catch (error) {
    console.error('Error fetching Model paper:', error);
    Swal.fire({
      title: 'Error',
      text: error.response?.data?.message || 'Failed to fetch Model paper',
      icon: 'error',
    });

    return [];
  }
}, 3000, {
  leading: true,
  trailing: false

})